import { Dialog as MuiDialog } from '@mui/material';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC, forwardRef, ReactElement, Ref } from 'react';

import { DialogProps } from '../types';

const Transition = forwardRef(
	(
		props: TransitionProps & {
			children: ReactElement<any, any>;
		},
		ref: Ref<unknown>,
	) => <Slide direction='up' ref={ref} {...props} />,
);

export const Dialog: FC<DialogProps> = ({ showDialog, setShowDialog }) => {
	const closeDialog = (__: any, reason: string) => {
		if (reason && reason === 'backdropClick') {
			return;
		}
		setShowDialog(null);
	};
	return (
		<MuiDialog
			PaperProps={{
				className: 'pca__main-modal',
			}}
			maxWidth='xl'
			TransitionComponent={Transition}
			open={!!showDialog}
			onClose={closeDialog}
		>
			{showDialog}
		</MuiDialog>
	);
};
